import React from 'react'
import { Container, Col, Row } from 'reactstrap'
import '../../Offer/offer.css'
import tick from '../../images/tick.png'
import windows from '../docs/aluminium_windows.pdf'
import doors from '../docs/aluminium_doors.pdf'
import arrow from '../arrow.png'
var Translate = require('react-translate-component')

export default class Windows2 extends React.Component {
  render () {
    return (
      <Container className='servicesContentContainer'>
        <Row>
          <Col md='12' sm='12' className='contentDescription pl-5'>
            <p className='contentTitle'>
              <Translate content='okna' />
            </p>
            <Row>
              <Col md='1' xs='1' sm='1' id='tickImg'>
                <img src={tick} alt='tick' />
              </Col>
              <Col md='11' xs='10' sm='10'>
                <p className='contentPoint'>
                  <Translate content='wszystkie_odmiany_okien' />
                  <b>
                    <Translate content='systemow_aluprof' />
                  </b>
                </p>
              </Col>
            </Row>
            <Row>
              <Col md='1' xs='1' sm='1' id='tickImg'>
                <img src={tick} alt='tick' />
              </Col>
              <Col md='11' xs='10' sm='10'>
                <p className='contentPoint'>
                  <Translate content='okucia_dobierane' />
                </p>
              </Col>
            </Row>
            <Row>
              <Col md='1' xs='1' sm='1' id='tickImg'>
                <img src={tick} alt='tick' />
              </Col>
              <Col md='11' xs='10' sm='10'>
                <p className='contentPoint'>
                  <Translate content='obsluga_w_sposob' />

                  <b>
                    <Translate content='manualnie_oraz_mechatronicznie' />
                  </b>
                </p>
              </Col>
            </Row>
            <Row>
              <Col md='1' xs='1' sm='1' id='tickImg'>
                <img src={tick} alt='tick' />
              </Col>
              <Col md='11' xs='10' sm='10'>
                <p className='contentPoint'>
                  <Translate content='mozemy_zapewnic' />
                </p>
              </Col>
            </Row>
            <Row>
              <Col md='1' xs='1' sm='1' id='tickImg'>
                <img src={tick} alt='tick' />
              </Col>
              <Col md='11' xs='10' sm='10'>
                <p className='contentPoint'>
                  <Translate content='okna_aluminiowe' />
                </p>
              </Col>
            </Row>
            <Row>
              <Col md='1' xs='1' sm='1' id='tickImg'>
                <img src={tick} alt='tick' />
              </Col>
              <Col md='11' xs='10' sm='10'>
                <p className='contentPoint'>
                  <b>
                    {' '}
                    <Translate content='odpornosc_na_wlamania' />
                  </b>
                </p>
              </Col>
            </Row>
            <Row>
              <Col md='1' xs='1' sm='1' id='tickImg'>
                <img src={tick} alt='tick' />
              </Col>
              <Col md='11' xs='10' sm='10'>
                <p className='contentPoint'>
                  <Translate content='ciezar_skrzydel' />
                </p>
              </Col>
            </Row>
            <Row>
              <Col md='1' xs='1' sm='1' id='tickImg'>
                <img src={tick} alt='tick' />
              </Col>
              <Col md='11' xs='10' sm='10'>
                <p className='contentPoint'>
                  <Translate content='drzwi_wejsciowe' />
                  <b>
                    <Translate content='z_kontrola_dostepu' />
                  </b>
                </p>
              </Col>
            </Row>
            <Row>
              <Col md='1' xs='1' sm='1' id='tickImg'>
                <img src={tick} alt='tick' />
              </Col>
              <Col md='11' xs='10' sm='10'>
                <p className='contentPoint'>
                  <Translate content='szyby_trzyszybowe' />
                </p>
              </Col>
            </Row>
            <Row>
              <Col md='1' xs='1' sm='1' id='tickImg'>
                <img src={tick} alt='tick' />
              </Col>
              <Col md='11' xs='10' sm='10'>
                <p className='contentPoint'>
                  <Translate content='lakierowanie_na_dowolnej_palecie' />
                </p>
              </Col>
            </Row>
            <Row>
              <Col md='1' xs='1' sm='1' id='tickImg' />
              <Col md='11' xs='10' sm='10'>
                <a target='_blank' className='offerCardDetails ' href={windows}>
                  <Translate content='czytaj_wiecej' />
                </a>
                <img src={arrow} alt='arrow' />
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col md='12' sm='12' className='contentDescription pl-5'>
            <p className='contentTitle'>
              <Translate content='drzwi_przesuwne' />
            </p>
            <Row>
              <Col md='1' xs='1' sm='1' id='tickImg'>
                <img src={tick} alt='tick' />
              </Col>
              <Col md='11' xs='10' sm='10'>
                <p className='contentPoint'>
                  <Translate content='wszystkie_odmiany_drzwi' />
                  <b>
                    <Translate content='systemow_aluprof' />
                  </b>
                </p>
              </Col>
            </Row>
            <Row>
              <Col md='1' xs='1' sm='1' id='tickImg'>
                <img src={tick} alt='tick' />
              </Col>
              <Col md='11' xs='10' sm='10'>
                <p className='contentPoint'>
                  <b>
                    <Translate content='wysokosc_skrzydel' />{' '}
                  </b>
                </p>
              </Col>
            </Row>
            <Row>
              <Col md='1' xs='1' sm='1' id='tickImg'>
                <img src={tick} alt='tick' />
              </Col>
              <Col md='11' xs='10' sm='10'>
                <p className='contentPoint'>
                  <Translate content='dla_wiekszego_komfortu' />
                  <b>
                    <Translate content='obslugiwane_za_pomoca' />
                  </b>
                </p>
              </Col>
            </Row>
            <Row>
              <Col md='1' xs='1' sm='1' id='tickImg'>
                <img src={tick} alt='tick' />
              </Col>
              <Col md='11' xs='10' sm='10'>
                <p className='contentPoint'>
                  <Translate content='wyposazenie_drzwi_przesuwnych' />
                </p>
              </Col>
            </Row>
            <Row>
              <Col md='1' xs='1' sm='1' id='tickImg'>
                <img src={tick} alt='tick' />
              </Col>
              <Col md='11' xs='10' sm='10'>
                <p className='contentPoint'>
                  <b>
                    <Translate content='system_kontroli_otwarcia' />
                  </b>
                </p>
              </Col>
            </Row>
            <Row>
              <Col md='1' xs='1' sm='1' id='tickImg'>
                <img src={tick} alt='tick' />
              </Col>
              <Col md='11' xs='10' sm='10'>
                <p className='contentPoint'>
                  <Translate content='izolacyjnosc_ponizej' />
                </p>
              </Col>
            </Row>
            <Row>
              <Col md='1' xs='1' sm='1' id='tickImg'>
                <img src={tick} alt='tick' />
              </Col>
              <Col md='11' xs='10' sm='10'>
                <p className='contentPoint'>
                  <Translate content='prog_zlicowany' />
                </p>
              </Col>
            </Row>
            <Row>
              <Col md='1' xs='1' sm='1' id='tickImg'>
                <img src={tick} alt='tick' />
              </Col>
              <Col md='11' xs='10' sm='10'>
                <p className='contentPoint'>
                  <b>
                    <Translate content='ukryte_ramy' />
                  </b>
                </p>
              </Col>
            </Row>
            <Row>
              <Col md='1' xs='1' sm='1' id='tickImg'>
                <img src={tick} alt='tick' />
              </Col>
              <Col md='11' xs='10' sm='10'>
                <p className='contentPoint'>
                  <b>
                    <Translate content='ciezar_skrzydel' />
                  </b>
                </p>
              </Col>
            </Row>
            <Row>
              <Col md='1' xs='1' sm='1' id='tickImg'>
                <img src={tick} alt='tick' />
              </Col>
              <Col md='11' xs='10' sm='10'>
                <p className='contentPoint'>
                  <Translate content='szyby_trzyszybowe' />
                </p>
              </Col>
            </Row>
            <Row>
              <Col md='1' xs='1' sm='1' id='tickImg'>
                <img src={tick} alt='tick' />
              </Col>
              <Col md='11' xs='10' sm='10'>
                <p className='contentPoint'>
                  <Translate content='lakierowanie_na_dowolnej_palecie' />
                </p>
              </Col>
            </Row>
            <Row>
              <Col md='1' xs='1' sm='1' id='tickImg' />
              <Col md='11' xs='10' sm='10'>
                <a target='_blank' className='offerCardDetails ' href={doors}>
                  <Translate content='czytaj_wiecej' />
                </a>
                <img src={arrow} alt='arrow' />
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    )
  }
}
